module.exports = __webpack_public_path__ + "img/EducationalTeachers.2e24f874.svg";